import { AbstractRenderer, Alignment, BusinessComponent, BusinessComponentOptions, CellPanel, ColumnPanel, ImageRenderer, RowPanel, StaticParagraphComponent } from '@blk/simba';
import { ChartType, ColumnChartName } from '@ddt-web/chart';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

import { DisclosureComponent } from '../disclaimers';
import { HeadingComponent, HeadingLevel } from '../heading/heading-component';
import { SvgImage } from '../helpers/static-pages/static-section/svg-image';
import { HighchartsSVGComponent } from '../highchart/highchart-svg-component';

@UntilDestroy()
export class RetirementIncomePictureComponent extends BusinessComponent {
	private incomeChartData: any;
	public customAttributes: any = {};

	constructor(
		public name: string,
		private incomeChartData$: Observable<any>,
		public visible: boolean = true
	) {
		super(name, 'BusinessComponent', BusinessComponentOptions.merge({ visible: visible }));
		this.incomeChartData$.pipe(untilDestroyed(this)).subscribe((response: any) => {
			this.incomeChartData = response?.incomeChart;
			this.customAttributes.customData = response?.incomeChartCustomAttributes;

		});
	}

	public buildComponent(): AbstractRenderer<SVGGElement>[] {
		const panels: AbstractRenderer<SVGGElement>[] = [];
		panels.push(
			...[
				new RowPanel('RETIREMENT INCOME PICTURE PAGE HEADER',
					[new HeadingComponent('RETIREMENT_INCOME_PICTURE_PAGE_HEADER', 'YOUR RETIREMENT INCOME PICTURE', HeadingLevel.H2)], { marginBottom: 4 }),
				new ColumnPanel('INCOME ', this.buildIncomeRow(),
					{}, Alignment.Horizontal.Left, Alignment.Vertical.Middle),
				...this.buildStackedColumnChart()
			]
		);
		return panels;
	}

	private buildIncomeRow(): RowPanel[] {
		const imageMarkup = new SvgImage('BAR_CHART').getStaticContent();
		const rows: RowPanel[] = [];
		rows.push(
			new RowPanel(
				'Income Title - Icon And Text Row',
				[
					new CellPanel([new ImageRenderer(imageMarkup, { height: 14, width: 14, paddingBottom: 2 })], { proportion: 4 }, Alignment.Horizontal.Left),
					new CellPanel([new HeadingComponent('PDF_DECUM_HISTOGRAM_CHART_PAGE_SUB_HEADER', 'Income', HeadingLevel.H2)], { proportion: 96 }, Alignment.Horizontal.Left)
				],
				{ marginTop: 10 },
				Alignment.Horizontal.Left,
				Alignment.Vertical.Middle
			)
		);
		rows.push(new RowPanel(
			'Retirement Page sub text',
			[
				new StaticParagraphComponent(
					'INCOME_SUB_TEXT',
					'Below is an estimate of your average sustainable income each year during retirement and the potential sources of that income.*',
					{},
					{},
					['text-10'])
			],
			{ marginBottom: 24 },
			Alignment.Horizontal.Left,
			Alignment.Vertical.Top
		));
		return rows;
	}

	private buildStackedColumnChart(): RowPanel[] {
		const panels: RowPanel[] = [];
		panels.push(new RowPanel(
			'Histogram Chart',
			[new HighchartsSVGComponent(ColumnChartName.IretireDecumHistogramChart, { height: 300, width: 800 }, this.incomeChartData, ChartType.Column, this.customAttributes)]
		));

		panels.push(new RowPanel(
			'Histogram Below Chart Description',
			[
				new DisclosureComponent('PDF_HISTOGRAM_BELOW_CHART_DESCRIPTION', 'Histogram below Chart Description')
			],
			{ marginTop: 20 },
			Alignment.Horizontal.Left,
			Alignment.Vertical.Top
		));


		// bolded more info text 
		panels.push(new RowPanel(
			'Histogram More Information text',
			[
				new StaticParagraphComponent('PDF_HISTOGRAM_CHART_MORE_INFO_TEXT', 'Histogram bolded more info text', {}, {}, ['text-8', 'text-bold'])
			],
			{ marginTop: 16 },
			Alignment.Horizontal.Left,
			Alignment.Vertical.Top
		));
		return panels;
	}
}
